// extracted by mini-css-extract-plugin
module.exports = {"galleryButton":"GalleryButton--galleryButton--1KgTc","placeholderAnim":"GalleryButton--placeholderAnim--27OMf"};